<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date">司机姓名：</label> 
					<span class="order-query-form-input"><input type="text" v-model="orderForm.name"  name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone" name="start-date"></span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">提现申请起始时间:<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.applyBeginTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.applyEndTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">申请状态：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.status" placeholder="请选择" class="stSetSelect" @change="changeStatus">
							<el-option
							v-for="item in statusList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">提现单号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.withdrawNo"  name="start-date"></span>
				</div>
				<!-- 新增提现渠道 -->
				<div class="order-query-form-box">
					<label for="start-date">提现渠道</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.cardTypes" placeholder="请选择" class="stSetSelect" @change="changeWithdrawalChannel">
							<el-option
							v-for="item in withdrawalChannelList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
			<div  >
				
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:showPage="togglePage"
				:showSummary="true" 
				:count-data="dataTotal"
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				:bottomSpareData="true"
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">

                <span slot="companyBalance" class="companyBalance" key="companyBalance">企晶灵余额：<span style="color: #FF5B3E">{{companyBalance}}</span>
                <span slot="zfbAccountBookBalance" class="zfbAccountBookBalance">支付宝记账本余额：<span style="color: #FF5B3E">{{zfbAccountBookBalance}}</span></span>
				</span>
			</common-table>
		</div>
		<el-dialog
			title="记账本转账"
			:visible.sync="dialogVisible"
			width="25%"
			:before-close="handleClose">

			<el-form :label-position="labelPosition" label-width="90px" :model="formLabel" style="margin-left: 30px">
				<el-form-item label="转账金额:">
					<el-input type="number" class="numrule" v-model="formLabel.amount" style="width: 220px" @input="handleValue" ></el-input>
				</el-form-item>
			</el-form>
			<div style="text-align:center;margin-top:30px">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="confirm">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'DriverWithdrawal',
	props: [],
	components: {},
	data(){
		return {
			tableColumns:[
			
				{
					type: 'selection',
					fixed: 'left',
				},	
				{
					key: '',
					title: '操作',
					align: 'center',
					operate: true,
					width: '200',
					setBtns: (row, index) => {
						return [{
							label: '拒绝审核',
							style: row.status === 0?"color:#FF5B3E;" :
								" color:#606266;",
							disabled: row.status === 0? false : true,
							handler: (row, index) => this.marginBack(row)
						},{
							label: '通过审核',
							style: "color:green;",
							disabled: row.status === 0? false : true,
							handler: (row, index) => this.passAudit(row)
						}]
					}
				},
				{
					title: '提现申请时间',
					key: 'createTimeFormatted'
				},{
					title: '提现单号',
					key: 'withdrawNo'
				},{
					title: '司机姓名',
					key: 'name'
				},{
					title: '司机手机',
					key: 'phone'
				},{
					title: '提现金额',
					key: 'withdrawAmount'
				},{
					title: '状态',
					key: 'statusDesc'
				},{
					title: '银行账号',
					key: 'cardNo'
				},{
					title: '开户人',
					key: 'bankIdName'
				},{
					title: '开户银行',
					key: 'bankName'
				},{
					title: '身份证号',
					key: 'bankIdCard'
				},{
					title: '审核人',
					key: 'checkName'
				},{
					title: '审核时间',
					key: 'checkTimeFormatted'
				}
			],
			bottomHandleArr: [
				// {
				// 	label: '拒绝审核',
				// 	handler: () => this.marginBack()
				// },

				// {
				// 	label: '通过审核',
				// 	type: 'success',
				// 	disabled:false,
				// 	handler: () => this.marginPass()
				// },
				// {
				// 	label: '查看公司余额',
				// 	type: 'success',
				// 	handler: () => this.handleShow()
				// },
				{
					label: '导出',
					type: 'success',
					handler: () => this.exportTable()
				},
				{
					label: '支付宝记账本',
					type: 'primary',
					handler: () => this.bookkeeping()
				},
			],
			pageConfig: {
				total: 0,
				pageSize: 100,
				currentPage: 1,
			},
			showPage:false,
			dataList:[], //数据列表
			dataTotal: {},
			backPass:false,// true  通过 false者退回
			orderForm:{
				applyBeginTime: null, //	提现申请起始时间	string	格式：yyyy-MM-dd HH:mm:ss
				applyEndTime: null, //	提现申请结束时间	string	格式：yyyy-MM-dd HH:mm:ss
				name: null, //	司机姓名	string	
				phone: null, //	司机手机	string	
				status: 0, //	申请状态	number	0=待审核、1=审核通过、2=审核不通过、3=提现处理、4=提现成功、5=提现失败、99=已取消
				withdrawNo: null, //	提现单号	string	
				// 提现渠道
				cardTypes:null,
			},
			togglePage:false, //是否显示分页
			selDriverId:null, //选中的司机
			selectedList:[],// 选中的列表
			driverList:[],// 司机列表
			toggleStDialog:false,// 弹窗
			statusList:[{
					value: 0,
					label: '待审核'
				},{
					value: 1,
					label: '审核通过'
				}, {
					value: 2,
					label: '审核不通过'
				},{
					value: 3,
					label: '提现处理'
				},{
					value:4,
					label: '提现成功'
				},{
					value:5,
					label: '提现失败'
				},{
					value:99,
					label: '已取消'
			}],
			// 提现渠道数组
			withdrawalChannelList:[{
					value: 'DC,CC',
					label: '银行卡'
				},{
					value: 'ZFB',
					label: '支付宝'
				}],
			// 公司余额
			companyBalance:'', 
			// 支付宝记账余额
			zfbAccountBookBalance: '',
			dialogVisible: false,
			formLabel: {
				amount: ""
			},
			labelPosition: 'left',
		}
	},
	created() {
		this.queryByCompanyBalance()
	},
	methods: {
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},
		currentChange(currentPage) {
			this.pageConfig.currentPage = currentPage
			this.searchList()
      	},
		getSummaries(param) {
				// 处理合计不显示问题
			this.$nextTick(() => {
				this.$refs.table.doLayout();
			});
			let vm = this;
			let sums = [];
			var selectedColm = param.columns;
			let newArray = []
			selectedColm.forEach(a => {
				if (vm.dataTotal[a.property]) {
				newArray.push(vm.dataTotal[a.property])
				} else {
				newArray.push('')
				}
			});
			sums = newArray;
			sums[0] = "合计";
			return sums;
		},
		selectionChange(val){
			this.selectedList=val;
		},
		cellClass(row){     
			// if (row.columnIndex === 0) {           
			// 	return 'disabledCheck'     
			// } 
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.$server.financial.getWithdrawCount(orderForm, (res) => {
				this.dataTotal = res.data
				
			})
			this.$server.financial.withdrawPage(orderForm,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}else{
						this.togglePage=false;
					}
				}
			})
		},
		
		// 通过审核
		marginPass(){
			let that=this;
			let data={};
			if(this.selectedList.length<1){
				that.$toast.stMessage('请选择订单',true)
				return;
			}
			let withdrawNos=this.selectedList.map(item=>{
				return item.withdrawNo
			})

			// withdrawAmount 提现金额
			let withdrawAmountTotal =this.selectedList.reduce((total,item)=>{
				if(item.withdrawAmount>0){
					return total+item.withdrawAmount;
				}
			},0)
			if(withdrawAmountTotal>this.companyBalance){
				return	this.$toast.stMessage(`提现金额不能大于公司余额`,false)
			}
			data.withdrawNos=withdrawNos;
			this.$server.financial.withdrawPass(data,(res)=>{ 
				if(res.code!=0){
					this.$toast.stMessage(res.message,false)
				}else{
					this.$toast.stMessage(`已通过审核`,true)
					this.searchList();
				}
			})
		},
		// 退回审核
		marginBack(row){
			console.log(row)
			let that=this;
			let data={};
			let setTime=setInterval(()=>{
				 data.withdrawNo=row.withdrawNo;
				 this.$server.financial.withdrawRefuse(data,(res)=>{ 
					if(res.code!=0){
						that.$toast.stMessage(res.message,false)
					}else{
						that.$toast.stMessage(`已退回审核`,true)
					}
				})
				clearInterval(setTime)
				that.searchList();
			},100)
		},
		//通过审核
		passAudit(row){
			console.log(row)
			let data = {}
			data.withdrawNo = row.withdrawNo
            this.$server.financial.withdrawPassNew(data,(res)=>{ 
				console.log(res);
				if(res.code != 0){
					this.$toast.stMessage(res.message,false)
				}else{
					this.$toast.stMessage(`已通过审核`,true)
					this.searchList()
				}
			})
		},
		//支付宝记账本
		bookkeeping(){
			console.log('点击了支付宝记账本')
			this.formLabel.amount = ''
			this.dialogVisible = true
		},
		async confirm(){
			if(this.formLabel.amount === ''){
				this.$toast.stMessage('转账金额不能为空',false)
				return
			}
			const reqData = {
				amount: this.formLabel.amount
			}
			const {data: reslut} = await this.$server.financial.transferAccountBook(reqData)
			if(reslut.code !== 0){
					this.$toast.stMessage(reslut.message,false)
				}else{
					this.$toast.stMessage('转账成功',true)
					this.queryByCompanyBalance()
				}
			this.dialogVisible = false
		},
		//关闭记账本弹窗
		handleClose(){
			this.formLabel.amount = ''
			this.dialogVisible = false
		},
		handleValue(value){
            if(!value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3")){
				this.formLabel.amount = ''
			}
		},
		// 导出
		exportTable() {
			let that = this;
			if (this.dataList.length < 1) {
				that.$toast.stMessage('暂无订单', true)
				return;
			}
			let pages = {};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			const sendData = {
				...this.orderForm,
				exportColumnFiledNames:  this.tableColumns.map((item) => {
						return item.exportProp || item.key
					}).filter(item => {
						return item && item.trim()
					})
			}
			sendData.createTimeBegin = sendData.createTimeBegin ? new Date(sendData.createTimeBegin).getTime() : ''
			sendData.createTimeEnd = sendData.createTimeEnd ? new Date(sendData.createTimeEnd).getTime() : ''
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/finance/withdraw-page-export', sendData, (res) => {
				console.log('导出成功')
			})
		},
		queryByCompanyBalance(){
			this.$server.financial.queryCompanyBalance({},(res)=>{
				console.log(res);
				this.companyBalance=res.data;
			})
			this.$server.financial.queryAccountBook({},(reslut) => {
				console.log(reslut);
				if(reslut.data.availableAmount === null){
					this.zfbAccountBookBalance = 'null'
					return
				}
				this.zfbAccountBookBalance = reslut.data.availableAmount
			})
		},
		changeStatus(val){
			if(val===0){
				this.bottomHandleArr.forEach(item=>{
					if(item.label=='通过审核'){
						item.disabled=false;
					}
				})
			}else{
				this.bottomHandleArr.forEach(item=>{
					if(item.label=='通过审核'){
						item.disabled=true;
					}
				})
			}
		},
		// 提现到渠道
		changeWithdrawalChannel(val){
		/* 	console.log('changeWithdrawalChannel',val)
			if(val===0){
				this.bottomHandleArr.forEach(item=>{
					if(item.label=='通过审核'){
						item.disabled=false;
					}
				})
			}else{
				this.bottomHandleArr.forEach(item=>{
					if(item.label=='通过审核'){
						item.disabled=true;
					}
				})
			} */
		}
	},
	mounted() {

	}
}

</script>
<style scoped>
.driver-withdrawal {
  width: 100%;
  height: auto;
}
.data-table-box {
    height: auto;
    background: #FFF;
    padding: 8px;
    box-sizing: border-box;
}	
.data-table{
	margin-bottom: 8px;
}
.query-setting-box-left{
    flex-grow: 0;
}
.companyBalance{
	height: 36px;
	line-height: 36px;
	font-weight: bold;
	font-size: 16px;
	padding:0 10px;
}
/* .companyBalance span{
	color: #FF5B3E;
} */
.zfbAccountBookBalance{
	padding:0 15px;
}
::v-deep .numrule input::-webkit-outer-spin-button,
::v-deep .numrule input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep .numrule input[type="number"] {
  -moz-appearance: textfield !important;
}
</style>
